export default "__VITE_ASSET__BJ0bqsVh__"